import * as React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { defaultTheme } from '@mindlercare/ui-web/src/shared/constants';

export interface ThinkingMessageProps {
    ariaLabel?: string;
}

const ThinkingBubble = styled.div({
    borderRadius: defaultTheme.BORDER_RADIUS.LG,
    padding: '12px 16px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: defaultTheme.SPACING.XS,
});

const bounce = keyframes`
    0%, 60%, 100% {
        transform: translateY(0);
        opacity: 0.7;
    }
    30% {
        transform: translateY(-8px);
        opacity: 1;
    }
`;

const Dot = styled.div<{ $delay: number }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${defaultTheme.COLORS.GRAY};
    animation: ${({ $delay }) => css`${bounce} 1.4s ease-in-out ${$delay}s infinite`};
`;

export const Thinking: React.FC<ThinkingMessageProps> = ({
    ariaLabel = "Assistant is thinking"
}) => {
    return (
        <ThinkingBubble aria-live="polite" aria-label={ariaLabel}>
            <Dot $delay={0} />
            <Dot $delay={0.2} />
            <Dot $delay={0.4} />
        </ThinkingBubble>
    );
};
